import { render, staticRenderFns } from "./RemoveDefaultHeaderAndFooter.vue?vue&type=template&id=81dbb05a&"
import script from "./RemoveDefaultHeaderAndFooter.vue?vue&type=script&lang=js&"
export * from "./RemoveDefaultHeaderAndFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports